module.exports = __webpack_public_path__ + "static/media/michigan.9338c886.png";